import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
} from "@material-ui/core";
import { AppBarButton } from "@ofqual/portal-components/components/SecondaryAppBar";
import { useDispatch } from "react-redux";
import { releaseApplication } from "../../../redux/actions";

export const ReleaseButtonAndDialog: React.FC<{ id: string }> = ({ id }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <AppBarButton
        text="Release"
        tooltip="Release"
        data-test="release-button"
        onClick={() => setIsOpen(true)}
      />
      {isOpen && <ReleaseDialog id={id} onClose={() => setIsOpen(false)} />}
    </>
  );
};

type ReleaseDialogProps = {
  id: string;
  onClose: () => void;
};

const ReleaseDialog: React.FC<ReleaseDialogProps> = ({ id, onClose }) => {
  const dispatch = useDispatch();

  const release = () => dispatch(releaseApplication(id));

  return (
    <>
      <Dialog open={true} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>Release Application</DialogTitle>
        <Divider component="div" />
        <DialogContent>
          Please confirm you wish to release this application
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            Cancel
          </Button>
          <Button data-test="release-application-confirm" onClick={release} color="primary">
            Release this application
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
